<template>
  <v-dialog v-model="openDialog" max-width="840" persistent>
    <v-card v-if="!showConfirmModal" class="pb-3 pt-4">
      <v-card-text>
        <div class="d-flex icon-container">
          <mf-icon fill x-large color="cinza-0"> warning </mf-icon>
          <div>
            <h3>Estes produtos estão sem faixa!</h3>
            <p>
              Os produtos listados aqui não possuem venda nos períodos selecionados, por isso não fomos capazes de colocá-los em faixas. Insira o preço ou
              selecione a faixa que eles serão alocados.
            </p>
          </div>
        </div>

        <v-data-table :headers="headers" :items="products" hide-default-footer hide-default-header disable-pagination height="340px">
          <template v-slot:header>
            <tr class="table-header">
              <th style="width: 75%">Produtos ({{ products.length }})</th>
              <th style="width: 25%">
                Preços
                <mf-tooltip max-width="250" top>
                  <template #activator="{ on }">
                    <mf-icon size="20" color="#fff">info</mf-icon>
                  </template>
                  <span
                    >Para podermos incluir esse produto em alguma faixa, informe um preço para esses produtos. Os produtos sem preço não serão incluídos na sua
                    análise.</span
                  >
                </mf-tooltip>
              </th>
            </tr>
          </template>
          <template v-slot:item="{ item, index }">
            <tr>
              <td>
                <a target="_blank" class="link" :href="`#/produtos/detalhes-produto/${item.sku}`">{{ item.name }}</a>
              </td>
              <td>
                <field-toggle v-model="item.price" money empty-money-label="Insira aqui" :row="index" />
              </td>
            </tr>
          </template>
        </v-data-table>
        <mf-action-buttons
          class="mr-2"
          :primary-button="{
            text: 'Inserir produtos',
            action: insertProducts,
            isVisible: true,
          }"
          :secondary-button="{
            text: 'Descartar produtos',
            action: discardAllProducts,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>

    <v-card v-else class="pt-6 pb-3">
      <v-card-text class="text-center discard-container">
        <mf-icon fill x-large color="cinza-0"> warning </mf-icon>
        <h4 class="mt-4">Os produtos sem preço informado serão descartados</h4>
        <p>
          Os produtos listados aqui não possuem venda nos períodos selecionados, por isso não fomos capazes de colocá-los em faixas. Sem incluir um preço, esses
          produtos serão descartados, ou seja, não serão utilizados na sua análise.
        </p>

        <mf-action-buttons
          :primary-button="{
            text: 'Descartar',
            action: confirmDiscardProducts,
            isVisible: true,
          }"
          :secondary-button="{
            text: 'Voltar para edição',
            action: backToEdit,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FieldToggle from '@/modules/campanhas/gestao-ofertas-v2/views/components/FieldToggle.vue'
export default {
  name: 'ProductsWithoutPriceModal',
  components: {
    FieldToggle,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showConfirmModal: false,
    shouldDiscardAll: false,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Produtos',
          width: '50%',
        },
        {
          text: 'Preços',
          width: '50%',
        },
      ]
    },

    hasProductsWithoutPrice() {
      if (!this.products) return false
      return this.products.filter((product) => !product.price).length > 0
    },

    openDialog: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    insertProducts() {
      if (this.hasProductsWithoutPrice) {
        this.showConfirmModal = true
        return
      }
      this.showConfirmModal = false
      this.$emit('confirm-insert', this.products)
    },
    confirmDiscardProducts() {
      if (this.shouldDiscardAll) {
        this.showConfirmModal = false
        this.shouldDiscardAll = false
        this.$emit('confirm-insert', [])
      } else {
        const filteredProducts = this.products.filter((product) => !!product.price)
        this.showConfirmModal = false
        this.shouldDiscardAll = false
        this.$emit('confirm-insert', filteredProducts)
      }
    },
    discardAllProducts() {
      this.showConfirmModal = true
      this.shouldDiscardAll = true
    },
    backToEdit() {
      this.showConfirmModal = false
      this.shouldDiscardAll = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  overflow-y: auto;
  max-height: 400px;
}
.icon-container {
  align-items: flex-start;
  gap: 10px;
}

.discard-container {
  max-width: 750px;
  margin: 0 auto;
}

h3,
h4 {
  color: $cinza-d10;
  font-weight: 700;
  font-size: 22px;
}

h4 {
  font-size: 18px;
}

p {
  color: $cinza-0;
  font-size: 16px;
  line-height: 120%;
}

.table-header {
  background: $cinza-0;
}

::v-deep .v-data-table__wrapper {
  border-radius: 8px;
}

::v-deep th {
  color: white !important;
  font-size: 16px;
  font-weight: bold;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
}
</style>
